import { get as _get, every, isEmpty, isObject } from 'lodash';
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';

export interface DataMapperDictionary {
  [key: string]: string;
}

export const FieldRenameMapper = {
  renameAndPick: <D, R>(data: D, dict: DataMapperDictionary): R => {
    if (!data) return undefined as any;

    const newData: R = {} as any;
    Object.keys(dict).forEach((dictKey) => {
      newData[dictKey as keyof typeof newData] = _get(data, dict[dictKey]);
    });

    return newData;
  },

  rename: <D, R>(data: D, dict: DataMapperDictionary): R => {
    if (!data) return undefined as any;

    const newData: R = {} as any;
    const listDataMapper = Object.keys(dict).map((item) => dict[item]);

    Object.keys(data).forEach((item) => {
      if (!(listDataMapper.indexOf(item) >= 0)) {
        dict[item] = item;
      }
    });

    Object.keys(dict).forEach((dictKey) => {
      newData[dictKey as keyof typeof newData] = _get(data, dict[dictKey]);
    });

    return newData;
  },

  formatObjectKeys: <D>(obj: ExpectedAny): D => {
    const formattedObj: ExpectedAny = {};

    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        let formattedKey = key.toLowerCase().replace(/[^a-z0-9_]/g, '_');
        formattedKey = formattedKey.replace(/_+/g, '_');
        formattedKey = formattedKey.replace(/^_+|_+$/g, '');

        const value = obj[key];

        if (Array.isArray(value)) {
          formattedObj[formattedKey] = value.map((item: ExpectedAny) => {
            if (typeof item === 'string') return item;
            return FieldRenameMapper.formatObjectKeys(item);
          });
        } else if (typeof value === 'object' && value !== null) {
          formattedObj[formattedKey] = FieldRenameMapper.formatObjectKeys(value);
        } else {
          formattedObj[formattedKey] = value;
        }
      }
    }

    return formattedObj;
  },
};
export const standardizeData = {
  formatDataSocialCompany: (rawData: IListSocialMediaAI) => {
    const listSocialMediaAI = getArrayDefault<Array<ISocialMediaAIItem>>(rawData?.ai_socials).filter(
      (item) =>
        (item?.confidence || 0) > 0 &&
        every([item.url, item.display_name], (value) => {
          return !isEmpty(value) && value !== 'NOT_FOUND';
        }),
    );
    const socialMediasList = getArrayDefault(rawData?.db_socials?.social_medias).filter((item) => !isEmpty(item?.url));
    const chatsList = getArrayDefault(rawData?.db_socials?.chats).filter((item) => !isEmpty(item?.url));
    const directoriesList = getArrayDefault(rawData?.db_socials?.directories).filter((item) => !isEmpty(item?.url));

    return {
      db_socials: {
        social_medias: socialMediasList,
        chats: chatsList,
        directories: directoriesList,
      },
      ai_socials: listSocialMediaAI,
    };
  },
};
